// extracted by mini-css-extract-plugin
export default {"container":"CharacterExpressions_container__7hXf6","addExpressionButton":"CharacterExpressions_addExpressionButton__A48gi","button":"CharacterExpressions_button__SpYy7"};